"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = require("../Typography");

var _schema = _interopRequireDefault(require("./schema"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TITLE_MAP = {
  small: _Typography.P,
  medium: _Typography.H4,
  large: _Typography.H3
};

var Loading = function Loading(_ref) {
  var title = _ref.title,
      description = _ref.description,
      variant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      props = _objectWithoutProperties(_ref, ["title", "description", "variant", "size"]);

  var Title = TITLE_MAP[size];
  var inverted = variant === 'inverted';
  var textSize = size === 'small' ? 'small' : undefined;
  var titleColor = inverted ? 'snowWhite' : undefined;
  var descriptionColor = inverted ? 'fullMoon' : 'alaskanHusky';
  var showTextContainer = !!title || !!description;
  return _react.default.createElement(_styles.Container, _extends({
    loadingSize: size
  }, props), _react.default.createElement(_styles.AnimationContainer, {
    size: size
  }, _react.default.createElement(_styles.Bouncer, {
    inverted: inverted
  }), _react.default.createElement(_styles.Bouncer, {
    inverted: inverted,
    shadow: true
  })), showTextContainer && _react.default.createElement(_styles.TextContainer, {
    size: size
  }, title && _react.default.createElement(Title, {
    color: titleColor,
    size: textSize
  }, title), description && _react.default.createElement(_Typography.P, {
    size: textSize,
    color: descriptionColor
  }, description)));
};

Loading.defaultProps = {
  size: 'medium',
  variant: 'normal'
};
Loading.propTypes = _schema.default.propTypes;
var _default = Loading;
exports.default = _default;